import React from "react";
import { Reveal, WfButton, CreditChip } from "@/components/site/primitives";
import { SUPPORT_INTRO } from "@/content/support";
import { scrollToId } from "@/lib/scrollTo";

export const SupportHero = () => (
  <section id="top" className="relative flex min-h-[70vh] items-end overflow-hidden bg-[var(--wf-soil)]">
    <img
      src={SUPPORT_INTRO.heroImage}
      alt={SUPPORT_INTRO.heroAlt}
      loading="eager"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/45 to-black/30" />
    <div aria-hidden="true" className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/40 to-transparent" />

    <div className="wf-container relative z-10 pb-16 pt-36 sm:pb-24">
      <Reveal className="max-w-3xl">
        {SUPPORT_INTRO.eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.24em] text-[rgba(255,253,248,0.85)]">
            <span aria-hidden="true" className="h-px w-8 bg-[rgba(255,253,248,0.6)]" />
            {SUPPORT_INTRO.eyebrow}
          </span>
        )}
        <h1
          data-testid="support-hero-headline"
          className="mt-5 font-serif text-4xl font-semibold leading-[1.05] tracking-[-0.01em] text-white [text-shadow:0_2px_24px_rgba(0,0,0,0.45)] sm:text-6xl lg:text-7xl"
        >
          {SUPPORT_INTRO.title}
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-7 text-[rgba(255,253,248,0.92)] sm:text-lg">
          {SUPPORT_INTRO.lede}
        </p>
        <div className="mt-9 flex flex-wrap items-center gap-3">
          <WfButton as="a" href="#donate" onClick={(e) => { e.preventDefault(); scrollToId("donate"); }} variant="light" withArrow className="rounded-full px-7" data-testid="support-hero-donate-button">
            Donate now
          </WfButton>
        </div>
      </Reveal>
    </div>

    <CreditChip src={SUPPORT_INTRO.heroImage} className="absolute bottom-3 right-3 z-10 rounded-full bg-black/45 px-3 py-1 text-[11px] font-medium text-white/90 backdrop-blur-sm hover:bg-black/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" />
  </section>
);
